import { CheckCircleIcon, ClockIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid';

const statusConfig = {
  processed: {
    label: 'Processed',
    bgColor: 'bg-status-success/15',
    textColor: 'text-status-success',
    borderColor: 'border-status-success/30',
    icon: CheckCircleIcon,
    iconColor: 'text-status-success',
  },
  pending: {
    label: 'Pending',
    bgColor: 'bg-brand-amber/15',
    textColor: 'text-brand-amber',
    borderColor: 'border-brand-amber/30',
    icon: ClockIcon,
    iconColor: 'text-brand-amber',
  },
  failed: {
    label: 'Failed',
    bgColor: 'bg-status-error/15',
    textColor: 'text-status-error',
    borderColor: 'border-status-error/30',
    icon: ExclamationCircleIcon,
    iconColor: 'text-status-error',
  },
  processing: {
    label: 'Processing',
    bgColor: 'bg-status-info/15',
    textColor: 'text-status-info',
    borderColor: 'border-status-info/30',
    icon: ClockIcon,
    iconColor: 'text-status-info',
  },
};

export default function StatusBadge({ status, size = 'md', showIcon = true }) {
  const config = statusConfig[status] || statusConfig.pending;
  const Icon = config.icon;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1 font-semibold rounded-full border
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        ${sizeClasses[size]}
      `}
    >
      {showIcon && <Icon className={`w-3.5 h-3.5 ${config.iconColor}`} />}
      {config.label}
    </span>
  );
}
